var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.9857L14.7427 27.243C13.6175 28.3682 12.0913 29.0004 10.5 29.0004C8.90873 29.0004 7.38259 28.3682 6.25737 27.243C5.13214 26.1178 4.5 24.5916 4.5 23.0003C4.5 21.409 5.13214 19.8829 6.25737 18.7577L20.844 4.17101C21.2156 3.79963 21.6567 3.50507 22.142 3.30415C22.6274 3.10323 23.1476 2.99988 23.673 3C24.1983 3.00012 24.7185 3.10372 25.2038 3.30487C25.6891 3.50602 26.13 3.80079 26.5014 4.17234C26.8727 4.54389 27.1673 4.98496 27.3682 5.47035C27.5692 5.95574 27.6725 6.47595 27.6724 7.00128C27.6722 7.52661 27.5687 8.04678 27.3675 8.53207C27.1664 9.01737 26.8716 9.45829 26.5 9.82967L11.9027 24.427C11.524 24.79 11.0179 24.9884 10.4933 24.9818C9.96874 24.9751 9.4678 24.7627 9.09844 24.3901C8.72907 24.0176 8.52085 23.5149 8.51865 22.9903C8.51646 22.4657 8.72047 21.9613 9.0867 21.5857L19.5 11.1723M11.9147 24.4137L11.9014 24.427",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDocument);
export default __webpack_public_path__ + "static/media/sendDocument.e9a08e01ab3ac647566a70057d6dee9a.svg";
export { ForwardRef as ReactComponent };